import { history } from '../../helpers'
import { initApi } from '../api'
import { User } from '../../api/model/User'
import { IccUserApi } from '../../api/api/IccUserApi'
import { API_URL } from '../constants'

async function attemptLogin(username: string, password: string): Promise<{ user: User }> {
  const apiInstance = await initApi(API_URL, username, password)
  const user = apiInstance && (await apiInstance.userApi.current())

  if (!apiInstance) {
    throw new Error('user.invalid-username-or-password')
  }
  return {
    user: user,
  }
}

function logout(userApi: IccUserApi): void {
  //userApi.logout().then(() => history.push('/login'))
}

export const userService = {
  attemptLogin,
  logout,
}
